import { Pipe, PipeTransform } from '@angular/core';
import { StudyFile } from 'src/app/models/Study/study-file.model';
import { MediaCategory } from 'src/app/models/media/media-category.model';

@Pipe({
  name: 'leftOrRightPipe',
  pure: false,
})
export class LeftOrRightPipe implements PipeTransform {
  transform(studyFile: StudyFile, categories: MediaCategory[]): any {
    const category = categories.find((c) => c.id === studyFile.mediaCategoryId);
    return category?.name
      ? category.name?.toLowerCase().includes('right')
        ? 'RIGHT'
        : 'LEFT'
      : 'UNKNOWN';
  }
}
